<div class="flex flex-col lg:flex-row bg-white dark:bg-bg relative h-[100dvh]">
	<div class="flex flex-col w-full lg:w-2/5 overflow-y-auto relative bg-white dark:bg-bg max-h-full overflow-y-clip">
		<router-outlet></router-outlet>
	</div>
	<!-- Toaster component -->

	<app-toaster></app-toaster>
	@if (pwaCover$ | async) {
		<div class="hidden lg:block lg:w-3/5 lg:h-[100dvh] bg-cover bg-center" [style.background-image]="`url(${pwaCover$.value})`"></div>
	} @else {
		<div class="hidden lg:w-3/5 lg:h-[100dvh] bg-black lg:flex lg:justify-between lg:flex-col pb-16 pt-8 pr-8">
			<div class="text-white w-full flex justify-end"><img src="assets/logos/spotside_white_logo.svg" [alt]="'Spotside Logo'" class="h-auto w-14" /></div>
			<div class="text-white w-full flex justify-end font-bold text-4xl">Loyalty Wallet</div>
		</div>
	}
</div>
